import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import AccesoDetails from "../../accesos-detalles/AccesoDetails";

export default function DetailModal({
    usuario, closeModal, service, updateList
}) {
    return (
        <>
            <AccesoDetails usuario={usuario} service={service} onUpdate={updateList} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>
        </>
    );
}